export const getCimaCorgoData = () => ({
  name: "Cima Corgo",
  country: "Portugal",
  region: "Douro",
  description: "Cima Corgo est le cœur historique du Douro, produisant les meilleurs vins de Porto et les plus prestigieux rouges de la région.",
  type: "subregion",
  mapAreas: [
    { region: "Cima Corgo", x: 41, y: 30, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "19,000 ha",
    production: "600,000 hl",
    wineries: "150+ quintas",
    villages: "15 villages principaux",
    exportPercentage: "75% (Porto)"
  },
  characteristics: {
    climate: "Climat continental chaud, étés secs, hivers froids",
    soil: "Sols de schiste, terrasses escarpées",
    viticulture: "Vendanges manuelles, cépages mélangés sur pied, vieilles vignes"
  },
  wineStyles: {
    red: "Rouges puissants, tanniques, grande capacité de garde",
    fortified: "Porto de qualité supérieure, Vintage, LBV, Tawny"
  },
  history: "Cima Corgo est le berceau du vin de Porto. Les quintas historiques produisent des vins de renommée mondiale depuis le XVIIIe siècle.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, desserts au chocolat (Porto)",
  grapeVarieties: [
    {
      name: "Touriga Nacional",
      percentage: "25%",
      description: "Cépage roi du Douro, produisant des vins complexes et aromatiques",
      characteristics: "Complexe, aromatique, tanins fermes, notes de violette",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Touriga Franca",
      percentage: "20%",
      description: "Cépage d'assemblage, apportant élégance et fruité",
      characteristics: "Élégant, fruité, tanins soyeux, notes de fruits rouges",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Tinta Roriz",
      percentage: "15%",
      description: "Cépage d'assemblage, apportant structure et couleur",
      characteristics: "Structuré, coloré, tanins fermes, notes de fruits noirs",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Tinta Barroca",
      percentage: "15%",
      description: "Cépage d'assemblage, apportant douceur et rondeur",
      characteristics: "Doux, rond, tanins soyeux, notes de prune",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Tinto Cão",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant acidité et fraîcheur",
      characteristics: "Acidité vive, fraîcheur, notes d'agrumes",
      wineStyles: "Sec, léger, frais"
    },
    {
      name: "Tinta Amarela",
      percentage: "10%",
      description: "Cépage d'assemblage, apportant aromatique",
      characteristics: "Aromatique, notes florales, structure légère",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Sousão",
      percentage: "5%",
      description: "Cépage teinturier, apportant couleur intense",
      characteristics: "Coloré, intense, tanins fermes",
      wineStyles: "Sec, plein-corps, tannique"
    }
  ]
}); 